/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminGroupSaleStatus,
    AdminGroupSaleStatusFromJSON,
    AdminGroupSaleStatusFromJSONTyped,
    AdminGroupSaleStatusToJSON,
} from './AdminGroupSaleStatus';
import {
    AdminProductDetailGroupSaleMarketplace,
    AdminProductDetailGroupSaleMarketplaceFromJSON,
    AdminProductDetailGroupSaleMarketplaceFromJSONTyped,
    AdminProductDetailGroupSaleMarketplaceToJSON,
} from './AdminProductDetailGroupSaleMarketplace';

/**
 * 
 * @export
 * @interface AdminProductDetailGroupSale
 */
export interface AdminProductDetailGroupSale {
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailGroupSale
     */
    id: string;
    /**
     * 
     * @type {Array<AdminProductDetailGroupSaleMarketplace>}
     * @memberof AdminProductDetailGroupSale
     */
    marketplaces?: Array<AdminProductDetailGroupSaleMarketplace>;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailGroupSale
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailGroupSale
     */
    soldDate?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailGroupSale
     */
    soldPrice: string;
    /**
     * 
     * @type {AdminGroupSaleStatus}
     * @memberof AdminProductDetailGroupSale
     */
    status: AdminGroupSaleStatus;
}



export function AdminProductDetailGroupSaleFromJSON(json: any): AdminProductDetailGroupSale {
    return AdminProductDetailGroupSaleFromJSONTyped(json, false);
}

export function AdminProductDetailGroupSaleFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProductDetailGroupSale {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'marketplaces': !exists(json, 'marketplaces') ? undefined : ((json['marketplaces'] as Array<any>).map(AdminProductDetailGroupSaleMarketplaceFromJSON)),
        'name': json['name'],
        'soldDate': !exists(json, 'soldDate') ? undefined : json['soldDate'],
        'soldPrice': json['soldPrice'],
        'status': AdminGroupSaleStatusFromJSON(json['status']),
    };
}

export function AdminProductDetailGroupSaleToJSON(value?: AdminProductDetailGroupSale | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'marketplaces': !value.marketplaces ? undefined : ((value.marketplaces as Array<any>).map(AdminProductDetailGroupSaleMarketplaceToJSON)),
        'name': value.name,
        'soldDate': value.soldDate,
        'soldPrice': value.soldPrice,
        'status': AdminGroupSaleStatusToJSON(value.status),
    };
}

